import { Chip, IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  IcDeleteTrash,
  IcRefreshCheck,
  IcRefreshClose,
  IcStylusNote,
} from '@/assets/images';
import { colors } from '@/theme/variables';

const actions = (actionMethods: any): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          actionMethods.onStatusChanged?.(params.row);
        }}
      >
        {params.row?.isCorrected ? <IcRefreshClose /> : <IcRefreshCheck />}
      </IconButton>

      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          actionMethods.onEdit?.(params.row?._id);
        }}
      >
        <IcStylusNote />
      </IconButton>

      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          actionMethods.onDelete?.(params.row?._id);
        }}
      >
        <IcDeleteTrash />
      </IconButton>
    </>
  ),
});

const issue = () => ({
  field: 'issue',
  headerName: 'Issue',
  disableColumnMenu: true,
  renderCell: (params: any) => {
    const isCorrected = params.row?.isCorrected;
    return (
      <>
        <span
          style={{
            marginRight: '10px',
            ...(isCorrected && { textDecoration: 'line-through' }),
          }}
        >
          {params.row?.issueDate}
        </span>
        {isCorrected ? (
          <Chip color="success" label="Corrected violation" size="small" />
        ) : (
          <Chip color="error" label="Violation" size="small" />
        )}
      </>
    );
  },
});
const photoUrl = () => ({
  field: 'photoUrl',
  headerName: 'Photo',
  disableColumnMenu: true,
  renderCell: (params: any) => {
    return (
      <span>
        <a href={params.row?.photoUrl} style={{ color: colors.error.main }}>
          View photo
        </a>
      </span>
    );
  },
});
export const inspectionViolationsCols = (actionMethods: any) => {
  return {
    actions: () => actions(actionMethods),
    issue,
    photoUrl,
  };
};
